import {http} from '@/axios'

function getInitState() {
  return {
    pendingCities: false,
    loadedCities: false,
    promiseCitiesList: null,
    citiesList: [],
  }
}

export default {
  namespaced: true,
  state: getInitState(),
  mutations: {
    resetState(state) {
      Object.assign(state, getInitState())
    },
    setProperty(state, [key, value]) {
      if (!state.hasOwnProperty(key)) return
      state[key] = value
    }
  },
  actions: {
    load({commit, state}) {
      if (state.loadedCities) return Promise.resolve()

      if (state.pendingCities) {
        return state.promiseCitiesList
      }

      commit('setProperty', ['pendingCities', true])

      const promiseCitiesList = http.get('/api/order/cities').then(({data}) => {
        commit('setProperty', ['citiesList', data.data])
      }).finally(() => {
        commit('setProperty', ['loadedCities', true])
        commit('setProperty', ['pendingCities', false])
        commit('setProperty', ['promiseCitiesList', null])
      })

      commit('setProperty', ['promiseCitiesList', promiseCitiesList])

      return promiseCitiesList
    }
  }
}
